var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 8,
  viewBox: "0 0 25 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 4H24M24 4L20.5 1M24 4L20.5 7",
  stroke: "currentColor",
  strokeWidth: 1
})));
export default SvgIconArrow;